import { Alert, IconButton } from '@components'
import { Reply, X } from 'lucide-solid'
import { Show } from 'solid-js'
import { useService } from 'solid-services'
import { useUpsert } from '../state'
import { generateParentPreviewText } from '../state/generateParentPreviewText'

export default function () {
	const { replyMessage, setReplyMessage } = useService(useUpsert)()

	const previewText = () => generateParentPreviewText(replyMessage()?.content)

	return (
		<Show when={replyMessage()}>
			<Alert.Root
				background="bg.canvas"
				w="calc(100% - var(--spacing-2))"
				ml={1}
				transform={'translateY(var(--spacing-2))'}
			>
				<Alert.Icon
					asChild={(iconProps) => (
						<Reply
							size="xs"
							{...iconProps()}
						/>
					)}
				/>
				<Alert.Content
					position="relative"
					width="100%"
				>
					<Alert.Title>
						Reply to: {(replyMessage()?.profile as any)?.username}
					</Alert.Title>
					<Alert.Description>{previewText()}</Alert.Description>
					<IconButton
						onClick={() => setReplyMessage(undefined)}
						position="absolute"
						top="0"
						right="0"
						variant="outline"
						size="xs"
					>
						<X />
					</IconButton>
				</Alert.Content>
			</Alert.Root>
		</Show>
	)
}
